export default "__VITE_ASSET__e8c286cd__"